import { render, staticRenderFns } from "./ModalVendorTransactions.vue?vue&type=template&id=50183ef2&scoped=true"
import script from "./ModalVendorTransactions.vue?vue&type=script&lang=js"
export * from "./ModalVendorTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50183ef2",
  null
  
)

export default component.exports